import { Pipe, PipeTransform } from '@angular/core';

import { representanteSituacoes } from '../representante-situacao';

@Pipe({
    name: 'representanteSituacao'
})
export class RepresentanteSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = representanteSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return representanteSituacoes[index].nome;
        }
        return '';
    }
}
